"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecodeToken = DecodeToken;
var jwt = __importStar(require("jsonwebtoken"));
var jwk_to_pem_1 = __importDefault(require("jwk-to-pem"));
var response_1 = require("@ca/wrap-sdk/src/response");
// TODO: This should be loaded on demand based on the stage.
var JWT_KEYS_DEV = require("./cognito-jwk-dev.json").keys;
var JWT_KEYS_PROD = require("./cognito-jwk-prod.json").keys;
var JWT_COGNITO_IDENTITY = require("./cognito-identity-jwk.json").keys;
var DEV_ISS = "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_qP6SBFjGy";
var PROD_ISS = "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_iFpfJySXw";
var DEVELOPER_IDENTITY_ISS = "https://cognito-identity.amazonaws.com";
var PEM_KEY_LUT = (_a = {},
    _a[DEV_ISS] = JWT_KEYS_DEV.map(function (jwk) { return (0, jwk_to_pem_1.default)(jwk); }),
    _a[PROD_ISS] = JWT_KEYS_PROD.map(function (jwk) { return (0, jwk_to_pem_1.default)(jwk); }),
    _a[DEVELOPER_IDENTITY_ISS] = JWT_COGNITO_IDENTITY.map(function (jwk) { return (0, jwk_to_pem_1.default)(jwk); }),
    _a);
function DecodeToken(token) {
    var result;
    // Get the issuer and the algorithm
    var decoded = jwt.decode(token, { complete: true });
    if (!decoded) {
        return (0, response_1.ErrorResponse)("Not JWT token");
    }
    var iss = decoded['payload'].iss;
    var alg = decoded['header'].alg;
    if (!(iss in PEM_KEY_LUT)) {
        return (0, response_1.ErrorResponse)({
            msg: "Iss issuer not found",
            iss: decoded.iss,
        });
    }
    var pem_keys = PEM_KEY_LUT[iss];
    for (var i = 0; i < pem_keys.length; i++) {
        try {
            result = jwt.verify(token, pem_keys[i], { algorithms: [alg] });
            result.token = token;
            break;
        }
        catch (err) {
        }
    }
    return (0, response_1.SuccessResponse)(result);
}
//# sourceMappingURL=decode.js.map